export const queryKeys = {
  ARTICLES: 'GET-ALL-ARTICLES',
  ARTICLES_CATEGORY: 'GET-ALL-ARTICLES-CATEGORY',
  ARTICLE_BY_SLUG: 'ARTICLE_BY_SLUG',
  RECOMMENDED_ARTICLES: 'RECOMMENDED_ARTICLES'
};
